import { Utils } from '@/utilities/Utils';

export interface IBookingRoomTotalsVM {
    profileID: number;
    date: Date;
    roomsRequired: number;
    roomsAssigned: number;
}

export class BookingRoomTotalsVM implements IBookingRoomTotalsVM {

    constructor(data?: IBookingRoomTotalsVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingRoomTotalsVM) {
        Utils.clone(data, this);
    }

    profileID: number = 0;
    date: Date = new Date(Utils.emptyDateValue);
    roomsRequired: number = 0;
    roomsAssigned: number = 0;

    get textColour() {
        if (this.roomsRequired == this.roomsAssigned) {
            return "black";
        } else if (this.roomsRequired != this.roomsAssigned) {
            return "red";
        }
    }

    get allRoomsRequired() {
        return this.roomsAssigned == this.roomsRequired;
    }
}